import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-renew',
    templateUrl: './renew.component.svg',
    styleUrls: ['./renew.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenewComponent {}
